// Ordinary invalidations do not obsolete a snapshot. Confirmed reads do.
export function createUnreadSnapshotState() {
    let applied = 0, barrier = 0, required = 0, dirtySince = null;
    let changes = [], manualRefreshAt = null;
    return {
        invalidate(eventId = 0) {
            const id = Number(eventId) || 0;
            if (id > Math.max(applied, required)) {
                changes.push({id, at: Date.now()});
                // Bounded checkpoints retain the oldest unresolved change's
                // age even during an extended outage.
                if (changes.length > 64) changes.splice(0, 2, {id: changes[1].id, at: changes[0].at});
            } else if (!id && !changes.length && manualRefreshAt === null) manualRefreshAt = Date.now();
            required = Math.max(required, id);
            dirtySince = changes[0]?.at ?? manualRefreshAt;
        },
        confirmRead(eventId) {
            barrier = Math.max(barrier, Number(eventId) || 0);
            this.invalidate(eventId);
        },
        accepts(payload) {
            const watermark = Number(payload?.snapshot_event_id);
            if (!Number.isSafeInteger(watermark)) return barrier === 0 && applied === 0;
            return watermark >= Math.max(applied, barrier);
        },
        apply(payload) {
            if (!this.accepts(payload)) return false;
            applied = Math.max(applied, Number(payload?.snapshot_event_id) || 0);
            changes = changes.filter(change => change.id > applied);
            manualRefreshAt = null;
            dirtySince = changes[0]?.at ?? null;
            return true;
        },
        isDirty() { return dirtySince !== null; },
        freshnessMs() { return dirtySince === null ? 0 : Math.max(0, Date.now() - dirtySince); },
        isStale() { return dirtySince !== null && Date.now() - dirtySince >= 10000; },
        reset() { applied = 0; barrier = 0; required = 0; dirtySince = null; changes = []; manualRefreshAt = null; },
    };
}
